const collection = {
    slug: "comme-des-garcons-2018ss-multi-dimensional-graffiti-guide",
    metaTitle:
      "COMME des GARCONS 2018SSとは｜Multi-dimensional Graffitiと買取・レンタルガイド",
    metaDescription:
      "COMME des GARCONS 2018SS『Multi-dimensional Graffiti』を解説。川久保玲がアルチンボルド、高橋真琴、雪村など異なる時代・国籍・表現のアーティスト作品を立体的な服の上で衝突させた重要シーズン。COMME des GARCONS買取・レンタル導線までEnclopediaが詳しく案内します。",
    metaKeywords:
      "COMME des GARCONS 2018SS,COMME des GARÇONS 2018SS,コムデギャルソン 2018SS,コムデギャルソン 2018春夏,Multi-dimensional Graffiti,コムデギャルソン Multi-dimensional Graffiti,コムデギャルソン アルチンボルド,COMME des GARCONS アルチンボルド,コムデギャルソン 高橋真琴,COMME des GARCONS 高橋真琴,コムデギャルソン 雪村,コムデギャルソン アート,コムデギャルソン 立体,コムデギャルソン ドレス,コムデギャルソン 名作,COMME des GARCONS 名作,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン レンタル,COMME des GARCONS レンタル,川久保玲 2018SS,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-2018ss-multi-dimensional-graffiti-guide",
    heroImage:
      "media/archive_fashion/archive20.png",
    heroImageAlt:
      "COMME des GARCONS 2018SS Multi-dimensional Graffitiを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "20 / MULTI-DIMENSIONAL GRAFFITI",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARCONS 2018SS『Multi-dimensional Graffiti』",
    lead:
      "COMME des GARCONS 2018SS『Multi-dimensional Graffiti』。\n\n川久保玲がこのシーズンで挑んだのは、服の上にアートを載せることではありません。\n異なる国、異なる時代、異なる感性から生まれた作品群を、巨大な立体の服の上で衝突させることでした。\n\nアルチンボルドの果物や野菜で構成された肖像。\n高橋真琴の少女画が持つロマンティックな目線。\n雪村の水墨画が持つ余白と筆致。\n\nそれぞれは本来、まったく別の文脈にある作品です。\nしかし2018SSでは、それらが服の表面に置かれるだけでなく、身体から大きく離れたボリューム、膨らんだシルエット、パッチワーク的な構成、玩具のような装飾とともに、立体的な“グラフィティ”として現れます。\n\nEnclopediaでは、このシーズンを、アートコラボレーションではなく、川久保玲が服を使って異なる表現の衝突を立体化したコレクションとして読み解きます。",
    keywordLine: [
      "multi-dimensional graffiti",
      "art on body",
      "archive dress",
      "comme des garcons buyback",
    ],
    thesis:
      "2018SS『Multi-dimensional Graffiti』の重要性は、アーティスト作品を服に引用した点ではなく、異なる時代・国籍・感性のイメージを、身体から離れた巨大な立体服の上で衝突させた点にあります。",
    whyTitle:
      "なぜCOMME des GARCONS 2018SSは、アートを“服の表面”ではなく“立体”にしたのか。",
    whyBody:
      "アート作品を服にプリントするだけなら、ファッションでは珍しいことではありません。\nしかしCOMME des GARCONS 2018SSで起きていることは、それとは違います。\n\nアルチンボルド、高橋真琴、雪村。\nそれぞれの作品は、時代も国籍も表現方法も異なります。\n西洋絵画、少女画、水墨画。\n果物や植物で構成された顔、夢見るような少女、墨の余白。\n\n川久保玲は、それらを一つの世界へきれいにまとめていません。\nむしろ、別々のまま衝突させています。\n\n巨大なドレス、身体から離れたコート、膨らんだ肩、天使の羽のような造形、玩具のようなヘアアクセサリー。\n服は、作品を飾る額縁ではなく、複数のイメージがぶつかる立体的な壁になります。\n\nつまり『Multi-dimensional Graffiti』とは、単にカラフルな落書きではありません。\n異なる表現が、身体の上で多層化し、立体化し、ひとつの服として成立する状態です。\n\nEnclopediaでは、この文脈を入口に、COMME des GARCONS 2018SSの買取相談、COMME des GARCONS全体のレンタル体験、そしてブランド理解へつなげます。",
    pillars: [
      {
        number: "01",
        title: "ART AS COLLISION",
        text:
          "2018SSでは、アートは服を飾るための図柄ではありません。異なる作品同士がぶつかり、服の上で新しい緊張感を作るための素材です。",
      },
      {
        number: "02",
        title: "BODY AS WALL",
        text:
          "身体は、服を着るための土台ではなく、イメージが立体的に貼り重なる壁のように扱われています。グラフィティが平面から身体へ移動したシーズンです。",
      },
      {
        number: "03",
        title: "BUYBACK TO RENTAL",
        text:
          "2018SSは、アート性、立体造形、作家性が重なる重要シーズンです。Enclopediaでは、買取相談を入口に、COMME des GARCONSのレンタル体験へ接続します。",
      },
    ],
    readingTitle:
      "アルチンボルド、高橋真琴、雪村、立体造形から読むCOMME des GARCONS 2018SS。",
    readingIntro:
      "このシーズンは、単に有名なアーティスト作品を使ったから重要なのではありません。なぜ異なる作品を同じ服の上で衝突させたのか、なぜ身体から離れた巨大な形が必要だったのか、なぜ少女画や水墨画や西洋絵画が同時に現れるのかを見ることで、川久保玲の“服とアートの距離”への問いが見えてきます。",
    observations: [
      {
        index: "01",
        title:
          "アートは、服を高級に見せるための装飾ではない",
        text:
          "2018SSでは、複数のアーティスト作品が服の上に現れます。\nしかしそれは、服を高級に見せるための引用ではありません。\n\nCOMME des GARCONSにおいて重要なのは、作品を美しく配置することではなく、作品同士の背景をぶつけることです。\n\n西洋絵画、少女画、水墨画。\nそれぞれは美術館、漫画文化、日本画、乙女文化といった別々の場所に属しています。\nその距離を無理に整えず、巨大な服の上で同時に存在させる。\n\nそこに、このシーズンの強度があります。",
      },
      {
        index: "02",
        title:
          "アルチンボルドは、身体とイメージの組み替えを象徴する",
        text:
          "アルチンボルドの作品は、果物、野菜、植物などを組み合わせて人間の顔を作ることで知られています。\n\n一つひとつのモチーフは別のものでありながら、集まると顔に見える。\nこれは、COMME des GARCONS 2018SSの構造と非常に近いものがあります。\n\n服もまた、異なる作品、異なる素材、異なるイメージを組み合わせて、一つの身体像を作っています。\n\nつまりアルチンボルドは、単なる絵柄として使われているのではありません。\n複数の断片から別の身体を作るという、川久保玲の造形と接続しています。",
      },
      {
        index: "03",
        title:
          "高橋真琴の少女画は、ロマンティックさだけでは終わらない",
        text:
          "高橋真琴の作品には、大きな瞳、花、リボン、少女の憧れ、ロマンティックな装飾性があります。\n\nしかし2018SSでその絵が巨大なCOMME des GARCONSの服に置かれると、単なる可愛らしさでは終わりません。\n少女的な夢や乙女文化が、身体から離れた巨大な造形の上に拡張される。\n\nその結果、ロマンティックなイメージは、甘さではなく、異様な強度を持ち始めます。\n\nEnclopediaの視点では、ここにCOMME des GARCONSらしい反転があります。\n可愛いものを、可愛いままでは終わらせない。\n少女的なイメージを、巨大なアーカイブピースへ変えてしまうのです。",
      },
      {
        index: "04",
        title:
          "雪村の水墨画は、余白と静けさを別の次元から差し込む",
        text:
          "雪村の水墨画は、アルチンボルドや高橋真琴とはまったく異なる感覚を持っています。\n墨、余白、筆致、静けさ。\n\nカラフルで過剰なイメージが並ぶ中で、水墨画の要素は別の時間を持ち込みます。\n\n華やかさだけで構成されるのではなく、墨の線や余白が入ることで、コレクションには東洋的な奥行きが生まれる。\n\n2018SSの面白さは、こうした相反する感覚が、同じランウェイ上で同時に成立している点にあります。",
      },
      {
        index: "05",
        title:
          "巨大なシルエットは、作品を“着る”ためではなく“立体化する”ためにある",
        text:
          "このシーズンの服は、とにかく大きく、身体から離れています。\nパッドや中綿によって、服は人間の輪郭を超えて広がります。\n\nなぜここまで巨大である必要があったのか。\nそれは、アート作品を単なるプリントとして見せるのではなく、身体の周囲に立体化するためです。\n\n服が身体に沿ってしまえば、作品はただの柄になります。\nしかし服が身体から離れることで、作品は空間を持つ。\n\n2018SSの服は、着る絵画ではなく、身体の周囲に立ち上がるイメージの彫刻です。",
      },
      {
        index: "06",
        title:
          "玩具のようなヘアアクセサリーは、子どもっぽさではなく記憶の集積である",
        text:
          "このシーズンでは、ソフビ人形、キャラクター、スマイルマーク、カラフルな玩具のような装飾も印象的です。\n\n一見すると、子どもっぽく、軽く、ポップに見えるかもしれません。\nしかし巨大な服と複数のアーティスト作品の上に置かれると、それは単なる遊びではなくなります。\n\n幼少期の記憶、消費文化、キャラクター、かわいさ、郷愁。\nそれらが髪や肩の周囲に集積することで、身体は個人の記憶と視覚文化の集合体のように見えてきます。",
      },
      {
        index: "07",
        title:
          "2018SSは、2017年の大規模な川久保玲評価の直後に現れた回答でもある",
        text:
          "2017年には、川久保玲の服が美術館的な文脈で大きく扱われました。\nCOMME des GARCONSの服が、単なるファッションではなく、身体、美、境界、造形を問い直す存在として見られるようになった時期です。\n\nその直後に発表された2018SSは、非常に興味深い位置にあります。\n川久保玲は、服を美術館的に静かに収めるのではなく、むしろイメージを爆発させる方向へ向かった。\n\nアートを扱いながら、美術品のように整えるのではない。\nグラフィティのように、過剰に、立体的に、身体の上で衝突させる。\n\nここに、COMME des GARCONSらしい反骨があります。",
      },
      {
        index: "08",
        title:
          "Multi-dimensional Graffitiとは、平面の落書きではなく、身体上の多層化である",
        text:
          "グラフィティは本来、壁や街に描かれるものです。\nしかし2018SSでは、その壁が身体になります。\n\nしかも、それは平面的なプリントではありません。\n巨大なボリューム、膨らんだ肩、立体的なパーツ、複数の作品の重なりによって、グラフィティは多次元化します。\n\n服は、絵を載せるキャンバスではなく、イメージが立体的に増殖する場所になる。\n\nこの読み方をすると、2018SSのタイトルは非常に正確です。",
      },
      {
        index: "09",
        title:
          "買取で見るべきなのは、作品名だけではなく“立体としての強さ”",
        text:
          "COMME des GARCONS 2018SSの買取では、単にアルチンボルド、高橋真琴、雪村といった作家名があるかどうかだけでは不十分です。\n\nどのルックに近いか。\nどれだけ2018SSらしい巨大な造形があるか。\nアーティスト作品が単なる柄ではなく、服の形とどう結びついているか。\n状態、サイズ、素材、付属品、販売時期、希少性。\n\nこのシーズンは、作家性と服の造形が同時に評価される領域です。\nEnclopediaでは、COMME des GARCONSの服を単なるブランド古着としてではなく、川久保玲のコレクション背景と現在の需要まで含めて確認します。",
      },
      {
        index: "10",
        title:
          "レンタルで分かるのは、アートを着るのではなく、アートに囲まれる感覚",
        text:
          "COMME des GARCONS 2018SSは、画像で見ると色や図柄の強さが先に目に入ります。\nしかし実際に着ると、身体から離れたボリューム、肩の広がり、作品が身体の周囲に浮く感覚がよりはっきり分かります。\n\nアートを着るというより、アートに囲まれる。\n服が身体に沿うのではなく、身体の周囲に別の空間を作る。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります。",
      },
    ],
    quote:
      "COMME des GARCONS 2018SSは、アートを服に載せたコレクションではない。異なるイメージを身体の周囲で立体的に衝突させたコレクションです。",
    perspectiveTitle:
      "Enclopediaは、COMME des GARCONSを“着る服”ではなく“身体と価値観を変えるアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "アルチンボルド、高橋真琴、雪村といった異なる表現を手がかりに、2018SSがどのようにアートと服の境界を揺らしたのかを読み解きます。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "COMME des GARCONSの立体的な服は、実際に着ることで理解が深まります。身体から離れる造形、重さ、空間の作り方をレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "シーズン背景、アーティスト作品、造形、素材、状態を知ることで、COMME des GARCONSの一着が単なる古着ではなく、アーカイブとしてどう評価されるのかが見えてきます。",
      },
    ],
    experienceTitle:
      "COMME des GARCONS 2018SSを売る前に、その一着がどの文脈にあるかを確認する。",
    experienceBody:
      "COMME des GARCONS 2018SSの買取では、ブランド名だけでなく、シーズン、テーマ、アーティスト作品、造形、素材、状態、サイズ、現在の需要が重要です。\n今回の記事では『Multi-dimensional Graffiti』を中心に解説していますが、Enclopediaが見ているのは2018SSだけではありません。\nCOMME des GARCONS、COMME des GARCONS HOMME PLUS、JUNYA WATANABE、noir kei ninomiya、BLACK COMME des GARCONSなど、コムデギャルソン周辺のアーカイブ全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\n2018SSを知ることは、COMME des GARCONSの服が持つ“アート性”と“造形性”の価値を見極める入口になります。",
    experienceItems: [
      "COMME des GARCONS 2018SSのタグ・シーズンを確認する",
      "Multi-dimensional Graffitiに近いアートプリント、巨大な造形、立体的なシルエットを撮影する",
      "アルチンボルド、高橋真琴、雪村などアーティスト作品に関連する図柄を確認する",
      "ドレス、コート、パッド、ボリューム、パッチワーク、装飾パーツの状態を確認する",
      "サイズ・状態・購入時期・付属品を確認する",
      "2018SSか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2018SSを入口に、COMME des GARCONSの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARCONSを単なるブランド古着としてではなく、川久保玲のデザイン哲学、シーズン背景、造形性、現在の需要まで含めて見ています。この記事で2018SS Multi-dimensional Graffitiの重要性に触れた方は、所有しているCOMME des GARCONSの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARCONS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons",
        productImage: "",
        text:
          "COMME des GARCONS 2018SS Multi-dimensional Graffitiを含むドレス、コート、ジャケット、立体造形、アートプリントのアーカイブまで。コムデギャルソンの買取対象と査定視点を確認できます。",
      },
      {
        label: "RENTAL FOCUS 02",
        title: "レンタルできるCOMME des GARCONSを見る",
        productPath:
          "/search/COMME%20DES%20GARCONS/",
        productImage: "",
        text:
          "COMME des GARCONSの立体的な服やアーカイブは、実際に着ることで理解が深まります。Enclopediaでコムデギャルソンのアーカイブを体験できます。",
      },
      {
        label: "BRAND FOCUS 03",
        title: "COMME des GARCONSブランド一覧へ",
        productPath:
          "/brand/COMME%20DES%20GARCONS（コムデギャルソン）/?number=10",
        productImage: "",
        text:
          "2018SSだけでなく、COMME des GARCONS、COMME des GARCONS HOMME PLUS、JUNYA WATANABE、BLACK COMME des GARCONSなどの取り扱いアイテムを確認できます。",
      },
    ],
    finalCta: {
      title:
        "Multi-dimensional Graffitiを読んだら、次はCOMME des GARCONSの価値を相談する。",
      body:
        "COMME des GARCONS 2018SSは、複数のアーティスト作品を巨大な立体服の上で衝突させ、服とアートの境界を揺らした重要シーズンです。\nEnclopediaでは、2018SSの買取相談を入口に、COMME des GARCONS全体のレンタル体験やブランド一覧へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "COMME des GARCONSをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;